<template>
    <el-dialog title="进仓单明细" :visible.sync="WarehouseNoDetailFlag" :destroy-on-close="true" width="80%" top="5%"
        style="text-align: center">
        <el-tabs class="warehouseTabs" v-model="activeName" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="汇总" name="summary"></el-tab-pane>
            <el-tab-pane label="申报" name="declare"></el-tab-pane>
        </el-tabs>
        <div class="warehouseTable">
            <el-table :data="tableData" border style="width: 100%" v-loading="tabLoading">
                <el-table-column v-for="(col, index) in column" :prop="col.prop" :width="col.width"
                    :min-width="col.minWidth || '110'" :align="col.align || 'center'" :label="col.label" :key="index">
                </el-table-column>
            </el-table>
        </div>
        <div class="toolbarPag">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" @current-change="currentChange"
                @size-change="sizeChange" :page-sizes="pageConfig.pageSizes" :page-size="pageConfig.pageSize"
                :current-page="pageConfig.pageIndex" :total="pageConfig.total" style="float:right;">
            </el-pagination>
        </div>
    </el-dialog>
</template>
  
<script>
import {
    GetDeliveryBoxInfoTaskAsyncApi
} from "@/api/transfer/tfDelivery/receiptManage.js";
export default {

    data() {
        return {
            tabLoading: false,
            allTableData: undefined,
            activeName: 'summary',
            pageConfig: {
                total: 0,
                pageIndex: 1,
                pageSize: 50,
                pageSizes: [10, 20, 50, 100]
            },
            tableData: [],
            column: [],
            declareColumn: [
                // 表格列配置
                {
                    prop: "customerBox",
                    label: "箱号",
                    minWidth: "200",
                },
                {
                    prop: "boxMark",
                    label: "箱唛",
                    align: "center",
                    minWidth: "200",
                },
                {
                    prop: "markHead",
                    label: "唛头",
                    align: "center",
                    minWidth: "100",
                },
                {
                    prop: "boxWeight",
                    label: "毛重（kg）",
                    minWidth: "100",
                },
                {
                    prop: "boxVolume",
                    label: "体积(cbm)",
                    minWidth: "100",
                },
                {
                    prop: "boxLength",
                    label: "长(cm)",
                    minWidth: "90",
                },
                {
                    prop: "boxWidth",
                    label: "宽(cm)",
                    minWidth: "90",
                },
                {
                    prop: "boxHeight",
                    label: "高(cm)",
                    minWidth: "90",
                },
                {
                    prop: "quantity",
                    label: "数量",
                 },
                // {
                //     prop: "skuCode",
                //     label: "产品编码",
                //     minWidth: "100",
                // },
                // {
                //     prop: "declareCName",
                //     label: "中文申报名称",
                //     minWidth: "150",
                // },
                // {
                //     prop: "declareEName",
                //     label: "英文申报名称",
                //     minWidth: "140",
                // },
                // {
                //     prop: "electricity",
                //     label: "是否含电",
                //     minWidth: "100",
                // },
            ],
            summaryColumn: [
                {
                    prop: "ownerCode",
                    label: "货主代码",
                },
                {
                    prop: "boxWeight",
                    label: "毛重(kg)",
                },
                {
                    prop: "boxVolume",
                    label: "体积(cbm)",
                },
                {
                    prop: "boxLength",
                    label: "长(cm)",
                },
                {
                    prop: "boxWidth",
                    label: "宽(cm)",
                },
                {
                    prop: "boxHeight",
                    label: "高(cm)",
                },
                {
                    prop: "boxCount",
                    label: "箱数",
                },
                {
                    prop: "declareCName",
                    label: "中文申报名称",
                },
                {
                    prop: "declareEName",
                    label: "英文申报名称",
                },
                {
                    prop: "electricity",
                    label: "是否含电",
                },
            ],
            WarehouseNoDetailFlag: false
        };
    },
    methods: {
        currentChange(val) {
            this.$set(this.pageConfig, 'pageIndex', val)
            this.setPagination(this.pageConfig)
        },
        sizeChange(val) {
            this.$set(this.pageConfig, 'pageSize', val);
            this.setPagination(this.pageConfig)
        },
        handleClick() {
            this.setTableColumn()
            this.setTableData()
        },
        setTableColumn() {
            if (this.activeName == 'summary') {
                this.column = this.summaryColumn
            } else {
                this.column = this.declareColumn
            }
        },
        setTableData() {
            this.setPagination({
                total: 0,
                pageIndex: 1,
                pageSize: 50,
                pageSizes: [10, 20, 50, 100]
            })
        },
        setPagination(pageConfig) {
            let tableData = []
            if (this.activeName == 'summary') {
                tableData = this.allTableData.summaryBoxInfoList
            } else {
                tableData = this.allTableData.boxInfoList
            }
            this.$set(this.pageConfig, 'total', tableData.length);
            this.$set(this.pageConfig, 'pageIndex', pageConfig.pageIndex);
            this.$set(this.pageConfig, 'pageSize', pageConfig.pageSize);
            let start = (pageConfig.pageIndex - 1) * pageConfig.pageSize
            this.tableData = tableData.slice(start, start + pageConfig.pageSize)
        },
        GetDeliveryBoxInfoTaskAsync(data) {
            this.tabLoading = true
            let para = {
                deliveryOrderID: data.tfDeliveryOrderID,
            }
            GetDeliveryBoxInfoTaskAsyncApi(para).then((res) => {
                this.tabLoading = false
                if (res.data && res.data.success) {
                    this.allTableData = res.data.response
                    this.setTableData()
                }
            })
        },
        showDalog(data) {
            this.activeName = 'summary'
            this.setTableColumn()
            this.tableData = []
            this.allTableData = []
            this.WarehouseNoDetailFlag = true
            this.GetDeliveryBoxInfoTaskAsync(data)
        }
    },
    mounted() {

    },
};
</script>

<style lang="less" scoped>
.warehouseTabs {
    box-shadow: none;
    border-bottom: none;
    ::v-deep>.el-tabs__content {
        padding: 0 !important;
    }
}

.warehouseTable {
    border-top: none;
    max-height: 500px;
    overflow: auto;
    padding: 15px;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
    border: 1px solid #DCDFE6;
    border-top: none;
}

.toolbarPag {
    overflow: hidden;
    padding-top: 10px;
}
</style>
  
  